export default __webpack_public_path__ + "static/media/small-logo.5d5bc2b5.svg";